export default "__VITE_ASSET__DwNUp7gF__"